import React from "react";
import { useDroppable } from "@dnd-kit/core";
import { ROOT_DROP_ZONE_ID } from "../utilities/dragUtils";

/**
 * Provides a clear drop area that returns a page back to the root level.
 * @param {{
 *   isVisible: boolean,
 *   isDisabled?: boolean,
 *   pageTitle?: string | null,
 *   folderTitle?: string | null,
 * }} props
 */
export function RootDropZone({
	isVisible,
	isDisabled = false,
	pageTitle = null,
	folderTitle = null,
}) {
	const { isOver, setNodeRef } = useDroppable({
		id: ROOT_DROP_ZONE_ID,
		data: { acceptsPage: true },
		disabled: isDisabled,
	});

	const className = [
		"root-dropzone",
		isVisible ? "root-dropzone--visible" : "",
		isOver ? "root-dropzone--over" : "",
	]
		.filter(Boolean)
		.join(" ");

	const hint =
		pageTitle && folderTitle
			? `Drop here to move "${pageTitle}" out of "${folderTitle}"`
			: "Drop here to move this page out of its folder";

	return (
		<div ref={setNodeRef} className={className} aria-hidden={!isVisible}>
			<div className="root-dropzone__label">
				<span className="root-dropzone__title">Move out of folder</span>
				<span className="root-dropzone__hint">{hint}</span>
			</div>
		</div>
	);
}
